
import { useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Testimonials from './components/Testimonials';
import ContactQuote from './components/ContactQuote';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ScrollToTop from '../../components/feature/ScrollToTop';

export default function Home() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.gavinluketreeandstumpservice.com';

    const schemas = [
      {
        id: 'schema-local-business',
        data: {
          '@context': 'https://schema.org',
          '@type': 'LocalBusiness',
          '@id': `${siteUrl}/#business`,
          name: 'Gavin Luke Tree and Stump Service',
          url: siteUrl,
          logo: `${siteUrl}/logo.png`,
          image: 'https://static.readdy.ai/image/2806d7657d5f4d36c9110f806a03accf/847b0e89c9a479336afdbb32ce8cb608.webp',
          description:
            'Professional tree removal, stump grinding and emergency tree service in Barossa Valley, Gawler and Adelaide. 25+ years experience. Licensed and insured.',
          telephone: '+61411597232',
          email: 'gavin@gavinluketreeandstumpservice.com',
          address: {
            '@type': 'PostalAddress',
            addressLocality: 'Nuriootpa',
            addressRegion: 'SA',
            addressCountry: 'AU',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: -34.5,
            longitude: 138.9,
          },
          areaServed: [
            { '@type': 'Place', name: 'Barossa Valley' },
            { '@type': 'Place', name: 'Gawler' },
            { '@type': 'Place', name: 'Adelaide Northern Suburbs' },
            { '@type': 'Place', name: 'Eudunda' },
            { '@type': 'Place', name: 'Blanchetown' },
          ],
          openingHoursSpecification: [
            {
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: [
                'Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday',
              ],
              opens: '00:00',
              closes: '23:59',
            },
          ],
          priceRange: '$$',
          hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: 'Tree Services',
            itemListElement: [
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Tree Removal' } },
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Stump Grinding' } },
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Emergency Tree Service' } },
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Tree Trimming and Pruning' } },
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Land Clearing' } },
              { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Debris Removal' } },
            ],
          },
          sameAs: [
            'https://www.facebook.com/gavinluketreeandstumpservice',
          ],
        },
      },
      {
        id: 'schema-website',
        data: {
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          '@id': `${siteUrl}/#website`,
          url: siteUrl,
          name: 'Gavin Luke Tree and Stump Service',
          description:
            'Expert tree removal, stump grinding and 24/7 emergency tree service in Barossa Valley, Gawler and Adelaide.',
          publisher: { '@id': `${siteUrl}/#business` },
          potentialAction: {
            '@type': 'SearchAction',
            target: `${siteUrl}/?s={search_term_string}`,
            'query-input': 'required name=search_term_string',
          },
        },
      },
      {
        id: 'schema-webpage',
        data: {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          '@id': `${siteUrl}/#webpage`,
          url: siteUrl,
          name: 'Gavin Luke Tree & Stump Service | Tree Removal Barossa Valley SA',
          description:
            'Expert tree removal, stump grinding & 24/7 emergency tree service in Barossa Valley, Gawler & Adelaide. 25+ years experience. Licensed & insured. Free quotes.',
          isPartOf: { '@id': `${siteUrl}/#website` },
          about: { '@id': `${siteUrl}/#business` },
          dateModified: '2025-07-14',
          inLanguage: 'en-AU',
          breadcrumb: {
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home',
                item: siteUrl,
              },
            ],
          },
        },
      },
    ];

    schemas.forEach(({ id, data }) => {
      let script = document.getElementById(id) as HTMLScriptElement | null;
      if (!script) {
        script = document.createElement('script');
        script.id = id;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(data);
    });

    return () => {
      schemas.forEach(({ id }) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Services />
      <WhyChooseUs />
      <Testimonials />
      <ContactQuote />
      <Footer />
      <ScrollToTop />
    </div>
  );
}